module.exports = __webpack_public_path__ + "60b5e72a48077e2fac9df969cc4159ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/event-create-black.png
// module id = 213
// module chunks = 0